var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCritical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 10.25C0.25 4.72692 4.72692 0.25 10.25 0.25C15.7731 0.25 20.25 4.72692 20.25 10.25C20.25 15.7731 15.7731 20.25 10.25 20.25C4.72692 20.25 0.25 15.7731 0.25 10.25ZM10.25 6.40385C10.454 6.40385 10.6497 6.48489 10.7939 6.62915C10.9382 6.77341 11.0192 6.96906 11.0192 7.17308V11.0192C11.0192 11.2232 10.9382 11.4189 10.7939 11.5632C10.6497 11.7074 10.454 11.7885 10.25 11.7885C10.046 11.7885 9.85033 11.7074 9.70607 11.5632C9.56181 11.4189 9.48077 11.2232 9.48077 11.0192V7.17308C9.48077 6.96906 9.56181 6.77341 9.70607 6.62915C9.85033 6.48489 10.046 6.40385 10.25 6.40385ZM10.25 14.8654C10.454 14.8654 10.6497 14.7843 10.7939 14.6401C10.9382 14.4958 11.0192 14.3002 11.0192 14.0962C11.0192 13.8921 10.9382 13.6965 10.7939 13.5522C10.6497 13.408 10.454 13.3269 10.25 13.3269C10.046 13.3269 9.85033 13.408 9.70607 13.5522C9.56181 13.6965 9.48077 13.8921 9.48077 14.0962C9.48077 14.3002 9.56181 14.4958 9.70607 14.6401C9.85033 14.7843 10.046 14.8654 10.25 14.8654Z",
    fill: "#EE3529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCritical);
export default __webpack_public_path__ + "static/media/critical.dda346fcfb67dc92627056c5a643fa82.svg";
export { ForwardRef as ReactComponent };